import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectBoundaryField');

    return {
        BOUNDARY: t('boundary'),
        BOUNDARY_IS_REQUIRED: t('boundaryIsRequired')
    };
};

export default useTranslation;
